import { redirect } from "@tanstack/react-router";
import { useAuthStore } from "@/lib/auth-store";
import { waitForAuthHydration } from "@/lib/auth-hydration";
import { PERMISOS } from "@/lib/permisos";

/**
 * Guard `beforeLoad` para las rutas de PASO del wizard de una solicitud
 * (captura/edición: cargar-cfdi, carga-invoice, cargar-zip, prorrateo,
 * proveedor, documentos, etc.).
 *
 * Hotspot 86 · esos pasos consumen endpoints que exigen `solicitudes.gestionar`
 * (y SOLO ese permiso). Antes el guard aceptaba también `contrapagos.gestionar`,
 * que ningún endpoint de captura usa: Mesa de Control (que lo tiene) entraba a
 * pantallas de captura cuyos controles respondían 403. Un viewer sin el permiso
 * que llegue por URL directa se redirige al detalle read-only de la solicitud.
 *
 * El gate de UI (stepper no navegable) evita el clic; este guard cubre el
 * acceso directo por URL. El backend sigue siendo la frontera real de seguridad.
 */
export async function requerirEdicionDeSolicitud({ params }: { params: { id: string } }) {
  await requerirPermisoOVolverAlDetalle(params.id, [PERMISOS.solicitudesGestionar]);
}

/**
 * Guard `beforeLoad` de `/solicitudes/$id/conciliar-cfdi` (P44 · Contrapago).
 * Conciliar el CFDI real exige `contrapagos.gestionar` en el backend (y ser el
 * dueño · lo valida la página y el handler). Sin el permiso → detalle read-only.
 */
export async function requerirConciliacionContrapago({ params }: { params: { id: string } }) {
  await requerirPermisoOVolverAlDetalle(params.id, [PERMISOS.contrapagosGestionar]);
}

async function requerirPermisoOVolverAlDetalle(id: string, requeridos: ReadonlyArray<string>) {
  await waitForAuthHydration();
  const permisos = useAuthStore.getState().user?.permisos ?? [];
  if (!requeridos.some((p) => permisos.includes(p))) {
    throw redirect({ to: "/solicitudes/$id", params: { id } });
  }
}
